import TablePagination from "components/Molecules/TablePagination"
import ActionMenu from "components/Organisms/ActionMenu"
import ActionMenuItem from "components/Organisms/ActionMenuItem"
import NewResourceButton from "components/Organisms/AddResourceButton"
import ModuleHeader, { Description } from "components/Templates/ModuleHeader"
import { useSearchFilter } from "hooks/searchFilterHooks"
import React, { useState } from "react"
import { useLocation } from "react-router-dom"
import VendorFilter from "./VendorFilter"
import VendorSummaryDrawer from "./VendorSummaryDrawer"
import VendorViewSwitch from "./VendorViewSwitch"

const VendorHeader = () => {
  const [isDrawerOpen, setDrawer] = useState(false)
  const location = useLocation()
  const [{ page, search }, setFilter] = useSearchFilter()
  const path = location.pathname

  function handleClick(value) {
    switch (value) {
      case "chart":
        setDrawer(true)
        return
      default:
        return
    }
  }
  return (
    <ModuleHeader
      className="vt-vendor-module-header"
      query={search}
      filter={<VendorFilter />}
      onQueryChange={search =>
        setFilter(prev => ({
          ...prev,
          search,
          page: 0,
        }))
      }
      header={<Description icon="user" title="Vendor" />}
    >
      <TablePagination
        disabled={path.includes("map")}
        page={page}
        onPageChange={page =>
          setFilter(prev => ({
            ...prev,
            page,
          }))
        }
        className="ml-3"
      />
      <VendorViewSwitch className="ml-3" />
      <ActionMenu onClick={handleClick} className="ml-3">
        <ActionMenuItem icon="chart" text="Summary" />
      </ActionMenu>
      <NewResourceButton
        className="ml-3"
        module="vendor"
        to="/d/registration/vendors/details/new"
      />
      <VendorSummaryDrawer
        isOpen={isDrawerOpen}
        onClose={() => setDrawer(false)}
      />
    </ModuleHeader>
  )
}

export default VendorHeader
